import React from "react";

import styles from "./Field.module.scss";

const CustomCheckbox = React.forwardRef(
  ({ checked, id, onChange, name, setChecked, value, type }, ref) => {
    return (
      <div
        className={`${styles.customCheckbox} ${checked ? styles.checked : ""}`}
        onClick={() => onChange(id, checked)}
      >
        <input
          className="d-none"
          type={type}
          id={id}
          name={name}
          checked={checked}
          value={value}
          ref={ref}
          onChange={(e) => onChange(e.target.id, e.target.checked)}
        />
      </div>
    );
  }
);

export default CustomCheckbox;
